/* Section-local, reversible FAQ and ingredient transitions with native keyboard controls. */
(() => {
  window.GrovaSections.register('grova-accordions', '.grova-pdp--faq, .grova-pdp--ingredients, .grova-faq-page', (root, scope) => {
    const items = [...root.querySelectorAll('details')];
    const animations = new Map();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    function setOpen(item, open, animate = true) {
      const answer = item.querySelector('.gnp-faq__answer, .gnp-science-answer, .grova-faq-page__answer');
      const height = item.open ? answer.getBoundingClientRect().height : 0;
      animations.get(item)?.cancel();
      animations.delete(item);
      item.dataset.faqOpen = String(open);
      item.querySelector('summary').setAttribute('aria-expanded', String(open));
      if (!animate || reducedMotion.matches || !answer.animate || (!item.open && !open)) {
        item.open = open;
        return;
      }
      item.open = true;
      const animation = answer.animate(
        [{ height: `${height}px` }, { height: open ? `${answer.scrollHeight}px` : '0px' }],
        { duration: 280, easing: 'cubic-bezier(.22, .61, .36, 1)', fill: 'both' },
      );
      animations.set(item, animation);
      animation.onfinish = () => {
        if (animations.get(item) !== animation) return;
        item.open = open;
        animations.delete(item);
        animation.cancel();
      };
    }
    function closeOthers(except) {
      items.forEach(item => {
        if (item !== except && item.dataset.faqOpen !== 'false') setOpen(item, false);
      });
    }
    scope.on(root, 'grova:tab-change', () => {
      items.forEach(item => {
        if (item.closest('[data-science-panel][hidden], [data-faq-panel][hidden], details[hidden]')) setOpen(item, false, false);
      });
    });
    const initial = items.find(item => item.open);
    items.forEach(item => {
      setOpen(item, item === initial, false);
      scope.on(item.querySelector('summary'), 'click', event => {
        event.preventDefault();
        const open = item.dataset.faqOpen !== 'true';
        closeOthers(item);
        setOpen(item, open);
      });
      scope.on(item, 'toggle', () => {
        if (animations.has(item)) return;
        if (item.open) closeOthers(item);
        setOpen(item, item.open, false);
      });
      const reveal = () => {
        closeOthers(item);
        setOpen(item, true, false);
      };
      scope.on(item, 'shopify:block:select', reveal);
      scope.on(item, 'grova:accordion-open', reveal);
    });
    scope.cleanup(() => {
      animations.forEach(animation => animation.cancel());
      animations.clear();
    });
  });
})();
